module.exports = __webpack_public_path__ + "static/media/Harvard.2035bfaa.png";